export enum ForgetPassword {
  SEND_EMAIL = 'SEND_EMAIL',
  CHECK_EMAIL = 'CHECK_EMAIL',
  RESET_PASSWORD = 'RESET_PASSWORD',
  RESET_DONE = 'RESET_DONE',
}
